import ExtendableError from 'es6-error';

/**
 * Error message that can safely be displayed to the user.
 */
export default class UserFriendlyError extends ExtendableError {
}


// WEBPACK FOOTER //
// ./src/errors/UserFriendlyError.js